import { authlessDynamicRoutes } from '@/ui/routes/routesNames/authlessRouteNames'

export function copyResponsibleMedicalRecordFillURL(uuid: string) {
  const url = new URL(location.href)
  url.pathname = authlessDynamicRoutes.responsibleMedicalRecordFill(uuid)
  navigator.clipboard.writeText(url.toString())
}
